export default "__VITE_ASSET__1c92ab37__"